import { Skeleton } from "@/components/ui/skeleton";

/**
 * Transcript-shaped placeholder shown while a conversation's messages load.
 * Mirrors `ChatMessages`' container + spacing so the real content swaps in
 * without a layout shift.
 */
export function ChatMessagesSkeleton() {
  return (
    <div className="min-h-0 flex-1 overflow-hidden">
      <div className="mx-auto w-full max-w-3xl px-4 py-6">
        <div className="flex flex-col gap-7">
          <UserBubble className="w-52" />
          <AssistantBlock widths={["w-[90%]", "w-[78%]", "w-[55%]"]} />
          <UserBubble className="w-40" />
          <AssistantBlock widths={["w-[85%]", "w-[65%]"]} />
        </div>
      </div>
    </div>
  );
}

/** Right-aligned user-message placeholder. */
function UserBubble({ className }: { className: string }) {
  return (
    <div className="flex justify-end">
      <Skeleton className={`h-9 rounded-xl rounded-br-md ${className}`} />
    </div>
  );
}

/** Left-aligned assistant placeholder: avatar square + a few text lines. */
function AssistantBlock({ widths }: { widths: string[] }) {
  return (
    <div className="flex gap-3">
      <Skeleton className="mt-0.5 size-7 shrink-0 rounded-md" />
      <div className="min-w-0 flex-1 space-y-2 pt-1">
        {widths.map((w, i) => (
          <Skeleton key={i} className={`h-4 ${w}`} />
        ))}
      </div>
    </div>
  );
}
